var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.module)?_c('KChip',_vm._b({},'KChip',_vm.settings,false),[_vm._v(_vm._s(_vm.settings.name)+" "),(_vm.module_id)?[_vm._v(" #"+_vm._s(_vm.module_id)+" "),_c('v-icon',{attrs:{"right":"","size":"12","color":_vm.settings.color}},[_vm._v("mdi-open-in-new")])]:_vm._e()],2):_c('KChip',{attrs:{"grey":""}},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }